import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-normaldevice',
  templateUrl: './normaldevice.component.html',
  styleUrls: ['./normaldevice.component.css']
})
export class NormaldeviceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
